/**
 * 결제 성공 컴포넌트
 * FSD: features/subscription/payment-result/ui
 */

import React from 'react';

interface PaymentSuccessProps {
  message: string;
  transactionId: string | null;
}

export const PaymentSuccess: React.FC<PaymentSuccessProps> = ({ message, transactionId }) => {
  return (
    <div className="payment-success">
      <div className="success-icon">✓</div>
      <h2>결제 성공</h2>
      <p className="message">{message}</p>
      {transactionId && (
        <div className="transaction-info">
          <p className="label">거래번호</p>
          <p className="transaction-id">{transactionId}</p>
        </div>
      )}
      <p className="redirect-notice">잠시 후 결제 내역 페이지로 이동합니다...</p>
    </div>
  );
};
